import {
  get,
  post,
  download
} from "../utils/http";

const warning = {
  page: params => post('/warning/page',params),
  status: params => post('/warning/status',params),
  update: params => post('/warning/update',params),
  handleWarning: params => post('/warning/handleWarning',params)
}

export default warning;



// WEBPACK FOOTER //
// ./src/api/warning.js